module.exports = __webpack_public_path__ + "img/transport_pic05.13925d13.jpg";